import styled from "@emotion/styled";

export const KnobDiv = styled("div")((props) => ({
    margin: "0px 10px",
    fontSize: "14px",
    textAlign: "center",
}));
